// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";
import ClassNames from "embla-carousel-class-names";

Alpine.directive("cards-films", (element, {}, { cleanup }) => {
  const OPTIONS = { align: "start", duration: 20, inViewThreshold: 0.9, watchResize: false } as const;

  const dom = {
    slides: element.querySelectorAll(".c-cards-films__slider-slide"),
    viewportNode: ensureHTMLElement(element.querySelector(".c-cards-films__slider-viewport")),
    nextBtnNode: ensureHTMLElement(element.querySelector(".c-cards-films__btn-next")),
    prevBtnNode: ensureHTMLElement(element.querySelector(".c-cards-films__btn-prev")),
  };

  let isScrolling = false;
  let lastProgress = 0;

  function onScroll(e) {
    if (!isScrolling) {
      dom.viewportNode.classList.add("is-scrolling");
      // Delelte any previous clone just in case and create a new one
      document.body.querySelectorAll(".c-card-film-details--open").forEach((el) => el.remove());
      isScrolling = true;
    }
    const progress = e.scrollProgress();
    if (Math.abs(progress - lastProgress) < 0.0003) {
      if (isScrolling) {
        dom.viewportNode.classList.remove("is-scrolling");
        isScrolling = false;
      }
    }
    lastProgress = progress;
  }

  const emblaApi = EmblaCarousel(dom.viewportNode, OPTIONS, [ClassNames()]);

  emblaApi.on("scroll", onScroll);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, {
    nextBtn: dom.nextBtnNode,
    prevBtn: dom.prevBtnNode,
  });

  emblaApi.on("destroy", removePrevNextBtnsClickHandlers);

  cleanup(() => {
    emblaApi.off("scroll", onScroll);
    emblaApi.destroy();
  });
});
